import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = { class: "d-flex gap-2 me-4" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  class: "table align-middle table-row-dashed fs-6 gy-2 table-hover",
  id: "table_accounts_requests"
}
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "id", -1)
const _hoisted_10 = { class: "" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "Ticket", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "Symbol", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "" }, "Volume", -1)
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_21 = ["onClick"]

import { onMounted, ref } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import RebateService from "@/projects/tenant/modules/rebate/services/RebateService";
import TimeShow from "@/components/TimeShow.vue";
import TradeRebateDetailModal from "@/projects/tenant/modules/rebate/components/modal/TradeRebateDetailModal.vue";
import {
  getTradeRebateStatusSelections,
  TradeRebateStatusTypes,
} from "@/core/types/TradeRebateStatusTypes";
import AccountDetail from "../../accounts/components/AccountDetail.vue";
import { User } from "@element-plus/icons-vue";
import { convertToUTC } from "@/core/utils/DateUtils";


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeRebate',
  setup(__props) {

const isLoading = ref(false);
const items = ref(Array<any>());
const accountSelected = ref(0);
const accountDetailRef = ref<InstanceType<typeof AccountDetail>>();
const tradeRebateDetailModalRef =
  ref<InstanceType<typeof TradeRebateDetailModal>>();
const criteria = ref<any>({
  page: 1,
  size: 20,
  completed: true,
  // statuses: [TradeRebateStatusTypes.Completed],
} as any);

const period = ref([] as any);
const tradeRebateSelections = getTradeRebateStatusSelections();
const fetchData = async (_page: number) => {
  criteria.value.page = _page;
  const datesRange = convertToUTC(period.value);
  criteria.value.closedFrom = datesRange.from;
  criteria.value.closedTo = datesRange.to;
  try {
    isLoading.value = true;
    const res = await RebateService.queryTradeRebate(criteria.value);
    items.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};
const selectedAccount = (id: number) => {
  accountSelected.value = id;
};
const clearSearchCriteria = async () => {
  criteria.value = {
    page: 1,
    size: 20,
    statuses: [TradeRebateStatusTypes.Completed],
  };
  await fetchData(1);
};

const showAccountDetail = (id: number) => {
  accountDetailRef.value?.show(id, "infos", [] as any);
};

onMounted(async () => {
  await fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_switch, {
            modelValue: criteria.value.completed,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((criteria.value.completed) = $event)),
            size: "large",
            "active-text": "Completed",
            "inactive-text": "Not Completed",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (fetchData(1)))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_input, {
              class: "w-125px",
              modelValue: criteria.value.accountNumber,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((criteria.value.accountNumber) = $event)),
              placeholder: "Account No.",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "w-100px",
              modelValue: criteria.value.ticket,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((criteria.value.ticket) = $event)),
              placeholder: "Ticket",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_input, {
              class: "w-100px",
              modelValue: criteria.value.symbol,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((criteria.value.symbol) = $event)),
              placeholder: "Symbol",
              clearable: ""
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_date_picker, {
              class: "w-300px me-3",
              modelValue: period.value,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((period).value = $event)),
              type: "daterange",
              "start-placeholder": _ctx.$t('fields.startDate'),
              "end-placeholder": _ctx.$t('fields.endDate'),
              format: "YYYY-MM-DD",
              "value-format": "YYYY-MM-DD HH:mm:ss"
            }, null, 8, ["modelValue", "start-placeholder", "end-placeholder"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (fetchData(1)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.search")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, { onClick: clearSearchCriteria }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("action.clear")), 1)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.accountNumber")), 1),
              _hoisted_11,
              _hoisted_12,
              _hoisted_13,
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.status")), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.closeTime")), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("fields.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && items.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
                'account-select': item.id === accountSelected.value,
              }),
                      onClick: ($event: any) => (selectedAccount(item.id))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.id), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (showAccountDetail(item.accountId)),
                          icon: _unref(User),
                          circle: "",
                          class: "me-1"
                        }, null, 8, ["onClick", "icon"]),
                        _createTextVNode(_toDisplayString(item.accountNumber), 1)
                      ]),
                      _createElementVNode("td", null, _toDisplayString(item.ticket), 1),
                      _createElementVNode("td", null, _toDisplayString(item.symbol), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$filters.digits(item.volume / 100)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.tradeRebateStatus.${item.status}`)), 1),
                      _createElementVNode("td", null, [
                        _createVNode(TimeShow, {
                          type: "exactTime",
                          "date-iso-string": item.closedOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", null, [
                        _createVNode(_component_el_button, {
                          onClick: ($event: any) => (tradeRebateDetailModalRef.value?.show(item))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t("action.viewDetails")), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ])
                    ], 10, _hoisted_21))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(TradeRebateDetailModal, {
      ref_key: "tradeRebateDetailModalRef",
      ref: tradeRebateDetailModalRef
    }, null, 512),
    _createVNode(AccountDetail, {
      ref_key: "accountDetailRef",
      ref: accountDetailRef
    }, null, 512)
  ]))
}
}

})